import { Dtos, type Rate, SuretyQuoteStatus } from "@inrev/common";
import { AdminBondRequest } from "@portal/api/bond-request/admin/types";
import { Modal } from "@portal/components/layout/Modal";
import { ModalItemWithHeader } from "@portal/components/layout/ModalItemWithHeader";
import { AdminUpdateBondRequestTermsForm } from "./AdminUpdateBondRequestTermsForm";

type AdminChangeBondRequestTermsModalProps = {
	request: AdminBondRequest & {
		status: Extract<SuretyQuoteStatus, "approved" | "accepted">;
	};
	bondForm: Dtos.Admin.SuretyBondForm.Get.Response;
	accountRate: Rate | undefined;
	onClose: () => void;
};

export const AdminChangeBondRequestTermsModal = ({
	request,
	bondForm,
	accountRate,
	onClose,
}: AdminChangeBondRequestTermsModalProps) => {
	return (
		<Modal onClickOutside={onClose}>
			<ModalItemWithHeader
				header="Change Bond Request Terms"
				onClose={onClose}
				bodyClassName="pt-[20px]"
			>
				<AdminUpdateBondRequestTermsForm
					request={request}
					bondForm={bondForm}
					accountRate={accountRate}
					onSubmit={onClose}
				/>
			</ModalItemWithHeader>
		</Modal>
	);
};
